import { render, staticRenderFns } from "./MessageDialogSection.vue?vue&type=template&id=5ee97c0b&scoped=true"
import script from "./MessageDialogSection.vue?vue&type=script&lang=ts"
export * from "./MessageDialogSection.vue?vue&type=script&lang=ts"
import style0 from "./MessageDialogSection.vue?vue&type=style&index=0&id=5ee97c0b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee97c0b",
  null
  
)

export default component.exports